import { Tooltip, Typography } from "antd";

const { Link } = Typography;

interface IDataObjectLinkProps {
    dataObjectId: string;
    onClick?: (dataObjectId: string) => void;
}

export default function DataObjectLink({ dataObjectId, onClick }: IDataObjectLinkProps) {
    // Middle truncate: first 4 + ... + last 4
    const truncateMiddle = (id: string) => {
        if (id.length <= 8) return id;
        return `${id.slice(0, 4)}...${id.slice(-4)}`;
    };

    return (
        <Tooltip placement="topLeft" title={dataObjectId}>
            <Link
                style={{
                    textOverflow: "ellipsis",
                    display: "block",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textDecoration: "underline",
                }}
                href={`${window.location.origin}/${dataObjectId}`}
                target="_blank"
                onClick={(e) => {
                    e.stopPropagation();
                    if (onClick) {
                        e.preventDefault();
                        onClick(dataObjectId);
                    }
                }}
            >
                {truncateMiddle(dataObjectId)}
            </Link>
        </Tooltip>
    );
}
